import React from 'react';
import './SlotReel.css';
// import slotBackground from '../images/HersoidPresentsWhite.png';

const SlotReel = ({ image, spinning }) => {
    return (
        <>
        <div className={`reel ${spinning ? 'spinning' : ''}`}>
            <div className='reel-container'
                 style={{
                     backgroundImage: `url(${image.path} )`,
                     backgroundSize: 'cover',        // or 'contain', depending on what you want
                     backgroundRepeat: 'no-repeat',
                     backgroundPosition: 'center center',
                     height: '100%',
                     width: '100%'
                 }}>
                    {/*<img src={image.path} alt="slot-symbol" className="reel-image" />*/}
                <div
                    className="slot-info"
                >



                {/*<p>{image.Web3Alignment}</p>*/}

                {/*<p>{image.Occupation}</p>*/}


                {/*<p>{image.ReligiousPersuasion}</p>*/}

                {/*<p>{image.Codename}</p>*/}

                {/*<p>{image.Pastime}</p>*/}

                {/*<p>{image.score}</p>*/}

                <p className="slot-name-title"><strong>{image.text}</strong></p>
                </div>
            </div>
            </div>

        </>
    );
};

export default SlotReel;